import { forwardRef } from 'react';

import * as ReactSelect from '@radix-ui/react-select';
import type { SelectItemProps } from '@radix-ui/react-select';

import { cn } from '@/lib/utils';

import IconCheck from '@/assets/icons/check.svg?react';

const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(({ children, className, ...props }, forwardedRef) => {
  return (
    <ReactSelect.Item
      className={cn(
        'relative flex h-9 cursor-pointer select-none items-center rounded pl-6 pr-4 text-sm leading-none text-gray-900 dark:text-gray-100',
        'data-[disabled]:pointer-events-none data-[disabled]:text-gray-400 dark:data-[disabled]:text-gray-500',
        'data-[highlighted]:bg-blue-1 data-[highlighted]:text-white data-[highlighted]:outline-none',
        className
      )}
      {...props}
      ref={forwardedRef}>
        <ReactSelect.ItemText>{children}</ReactSelect.ItemText>
        <ReactSelect.ItemIndicator className="absolute left-0 inline-flex w-6 items-center justify-center">
          <IconCheck />
        </ReactSelect.ItemIndicator>
    </ReactSelect.Item>
  );
});

export default SelectItem;
